// @flow
import { GET_SINGLE_RECIPE_DETAILS } from './actionTypes'

export default (recipeSlug: string) => ({
  type: GET_SINGLE_RECIPE_DETAILS,
  payload: {
    recipeSlug,
  }
})